import { z } from "zod";

import { MetaDataSchema } from "@/schemas/meta-data";

const StatusSchema = z.enum(["QUEUED", "RETRYING", "DELIVERED", "GIVEN_UP"]);
export const WebhookDeliverySchema = z.object({
	id: z.number(),
	deliveryId: z.string(),
	createdAt: z.string(),
	trigger: z.string().nullable(),
	status: StatusSchema,
	givenUpKind: z.enum(["RETRIES_SPENT", "FINAL_ANSWER", "NOT_SENT"]).nullable(),
	attemptCount: z.coerce.number(),
	lastHttpStatus: z.number().nullable(),
	lastResponseExcerpt: z.string().nullable(),
	lastError: z.string().nullable(),
	nextAttemptAt: z.string().nullable(),
	deliveredAt: z.string().nullable(),
	givenUpAt: z.string().nullable(),
	isRedelivery: z.boolean(),
	listId: z.number().nullable(),
	listPersonId: z.number().nullable(),
	lead: z.object({ name: z.string().nullable(), company: z.string().nullable() }).nullable(),
});
export const WebhookDeliveryPageSchema = z.object({
	data: z.array(WebhookDeliverySchema),
	meta: MetaDataSchema,
});
export const WebhookDeliveryDetailSchema = WebhookDeliverySchema.extend({
	list: z.object({ id: z.number(), name: z.string() }).nullable(),
	attempts: z.array(
		z.object({
			attemptNumber: z.number(),
			attemptedAt: z.string(),
			httpStatus: z.number().nullable(),
			outcome: z.enum(["DELIVERED", "RETRYABLE", "TERMINAL"]),
			answer: z.string().nullable(),
			durationMs: z.number().nullable(),
		})
	),
	redeliveries: z.array(z.object({ id: z.number(), status: StatusSchema, createdAt: z.string() })),
});
export const RedeliveryCountsSchema = z.object({
	resend: z.coerce.number(),
	skipped: z.object({
		retrying: z.coerce.number(),
		leadRemoved: z.coerce.number(),
		redeliveredAlready: z.coerce.number(),
		delivered: z.coerce.number(),
	}),
	skippedTotal: z.coerce.number(),
	max: z.coerce.number(),
	overLimit: z.boolean(),
});
export type WebhookDelivery = z.infer<typeof WebhookDeliverySchema>;
export type WebhookDeliveryPage = z.infer<typeof WebhookDeliveryPageSchema>;
export type WebhookDeliveryDetail = z.infer<typeof WebhookDeliveryDetailSchema>;
export type RedeliveryCounts = z.infer<typeof RedeliveryCountsSchema>;
export type DeliveryQuery = {
	webhookId: number;
	page: number;
	take: number;
	status?: "DELIVERED" | "RETRYING" | "GIVEN_UP";
	from?: string;
	to?: string;
};
export type RedeliveryRequest = {
	mode: "one" | "failed" | "range";
	deliveryId?: number;
	from?: string;
	to?: string;
	include?: "givenUp" | "all";
};
export type RedeliveryQuery = RedeliveryRequest & { webhookId: number };
